import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { SessionStore, SessionState } from './session.store';
import { AES_KEY } from '@core/constants';
import { Country } from '../../models/Country';

@Injectable({ providedIn: 'root' })
export class SessionQuery extends Query<SessionState> {
    get logged(): boolean {
        return this.getValue().userId !== '';
    }

    getKey(): string {
        return AES_KEY + this.getValue().secKey;
    }

    getCountryById(countryId: string): Country {
        return this.getValue().countries.find(({ id }) => id === countryId) ?? { id: '0', name: '' };
    }


    getOtpEnabled() {
        return this.getValue().otpEnabled;
    }

    getOtpRememberMe() {
        return this.getValue().otpRememberMe;
    }

    getOtpCookie() {
        return this.getValue().otpCookie;
    }


    constructor(protected store: SessionStore) {
        super(store);
    }

}
